import { render, staticRenderFns } from "./editAccount.vue?vue&type=template&id=5c95e8de&scoped=true&"
import script from "./editAccount.vue?vue&type=script&lang=js&"
export * from "./editAccount.vue?vue&type=script&lang=js&"
import style0 from "./editAccount.vue?vue&type=style&index=0&id=5c95e8de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c95e8de",
  null
  
)

export default component.exports